export default __webpack_public_path__ + "static/media/Boots of the Vanguard.5662f268.jpg";